module.exports = __webpack_public_path__ + "static/img/fenzu.4f4f3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/fenzu.png
// module id = tmqX
// module chunks = 24